import { pageTitle } from 'ember-page-title';
import { t } from 'ember-intl';

import PageAcceptInvitation from 'hcp/components/page/accept-invitation';

<template>
  {{pageTitle (t "page-title.accept-invitation")}}
  <main id="content">
    <PageAcceptInvitation
      @invitationToken={{@controller.model.invitationToken}}
      @organizationName={{@controller.model.organizationName}}
    />
  </main>
</template>
